let _ = require('../_.js');
var $ = jQuery;

// When rows have class 'smart-div', then if they have attributes data-sd-X where X is a css property,
// the field is evaluated and the returned value is set as that css property whenever ui_update is called.
// The value of 'this' in eval'd code is a jquery selector of the element.

// There are 3 other special setters:

// data-sd-show does .hide() and .show()
// data-sd-disabled enables / disables element
// data-sd-class-X - adds or removes the class named X in the attribute name.

_.ac_smart_div_init = function () {

    _.on_ui_resize(function () {

        let has_changed = false;
        $(".smart-div").each(function () {
            let $this = $(this);

            // Get all attributes of this element
            let attributes = this.attributes;

            // Iterate over all attributes
            $.each(attributes, async function (i, attribute) {
                // Check if attribute name starts with "data-sd-"
                if (attribute.name.startsWith('data-sd-')) {
                    // Get the remainder after "data-sd-"
                    let remainder = attribute.name.substring(8);

                    let evaluatable = attribute.value.trim();
                    let notCondition = evaluatable.startsWith('!');             // handle !promisable_function() as a special case
                    if (notCondition) evaluatable = evaluatable.substring(1);

                    if (evaluatable.indexOf('return') == -1 && evaluatable.indexOf(';') == -1) {
                        evaluatable = "return " + evaluatable + ";";
                    }

                    evaluatable = "(function(){ " + evaluatable + " }).bind($this)()";

                    // Get the eval() value from the attribute value
                    let evalResult;
                    try {
                        evalResult = await eval(evaluatable);
                        if (notCondition) evalResult = !evalResult;
                    } catch (e) {
                        // console.error(e);  // Log the error if there's an issue with eval()
                        return;  // Continue with the next attribute if there's an issue
                    }


                    // Check if remainder starts with "class-"
                    if (remainder.startsWith('class-')) {
                        // Get the class name from the remainder
                        let className = remainder.substring(6);
                        // Add or remove class based on evalResult
                        if (evalResult && !$this.hasClass(className)) {
                            $this.addClass(className);
                            has_changed = true;
                        } else if (!evalResult && $this.hasClass(className)) {
                            $this.removeClass(className);
                            has_changed = true;
                        }
                    }
                    // Check if remainder is "show"
                    else if (remainder === 'show') {
                        // Show or hide element based on evalResult
                        let isHidden = $this.is(":hidden");
                        if (evalResult && isHidden) {
                            $this.show();
                            has_changed = true;
                        } else if (!evalResult && !isHidden) {
                            $this.hide();
                            has_changed = true;
                        }
                    }
                    // Check if remainder is "disabled"
                    else if (remainder === 'disabled') {
                        // Enable or disable element based on evalResult
                        let isDisabled = $this.is(":disabled");
                        if (evalResult && !isDisabled) {
                            $this.attr('disabled', 'disabled');
                            has_changed = true;
                        } else if (!evalResult && isDisabled) {
                            $this.removeAttr('disabled');
                            has_changed = true;
                        }
                    }
                    // If remainder doesn't match any of the special cases, treat it as CSS property
                    else {
                        $this.css(remainder, evalResult);
                    }
                }
            });
        });

        if (has_changed) {
            _.ui_update();
        }
    });
}
